import axios from 'axios';
import authHeader from "@/service/auth-header";

class LabelService {

    async getCompanyLabels(companyId) {
        return await axios.get(`/api/label/${companyId}`, {headers: authHeader()})
    }

    async searchCompanyLabels(companyId, locationName) {
        return await axios.get(`/api/label/${companyId}/${locationName}`, {headers: authHeader()})
    }

    async getLabel(labelId) {
        return await axios.get(`/api/label/specific/${labelId}`, {headers: authHeader()})
    }

    async createLabel(companyId, data) {
        return await axios.post(`/api/label/${companyId}`, data, {headers: authHeader()});
    }

    async updateLabel(labelId, data) {
        return await axios.put(`/api/label/${labelId}`, data, {headers: authHeader()});
    }

    async deleteLabel(labelId) {
        return await axios.delete(`/api/label/${labelId}`, {headers: authHeader()})
    }

}

export default new LabelService();
